import React, { Component } from "react";

import img1 from "../../../Assets/img/title.svg";
import img3 from "../../../Assets/img/red-carpet.svg";
import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";
import prize_mobile from "../../../Assets/img/prize_mobile.png";
import second_prize from "../../../Assets/img/second_prize.png";
import third_prize from "../../../Assets/img/third_prize.png";
import fourth_prize from "../../../Assets/img/fourth_prize.png";
import montly_prize1 from "../../../Assets/img/montly_prize1.png";
import montly_prize2 from "../../../Assets/img/montly_prize2.png";
import montly_prize3 from "../../../Assets/img/montly_prize3.png";
import montly_prize4 from "../../../Assets/img/montly_prize4.svg";
import montly_prize5 from "../../../Assets/img/montly_prize5.png";
import montly_prize6 from "../../../Assets/img/montly_prize6.png";
import montly_prize7 from "../../../Assets/img/montly_prize7.png";


class Prize_winners extends Component {

  constructor(props) {
    super(props);
    this.state = {
      validation_alert : false,
      validation_error : false,
      validation_blank : false,
    };
  }
 
  
  render() {
    return (
      <div className="Prizes">
        <div className="row">
          <div className="col-12 middle-part w-100 pt-3">
            <div className="container">
              <div className="row text-center winner_prizes">
               <div className="col-md-10 offset-md-1">
                 <h4 className="pt-3">WINNER TAKES ALL</h4>
                 <p> The joy of finishing first is unparalleled. We will make the achievement even sweeter with this prize.</p>
                 <img src={prize_mobile} alt="..." /> 
                 <h5> ONEPLUS NORD </h5>
                 <hr />
               </div> 
              </div>
            </div>  
            
            <div className="container">
            <div className="row mt-4 section-2">
              <div className="col-md-4 col-12 offset-md-2 text-center">
                <div className="avatar-circle-mm ml-auto mr-auto">
                  <span className="initials initials-img">
                    <img className="media-object pl-1" src={img1} alt="..." />
                  </span>
                </div>
                <p className="mt-4">PUZZLER TITLE</p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <div className="avatar-circle-mm ml-auto mr-auto">
                  <span className="initials initials-img">
                    <img className="media-object pl-1" src={img3} alt="..." />
                  </span>
                </div>
                <p className="mt-4"> HALL OF FAME</p>
              </div>
            </div>
            </div>
          </div>
          <div className="powerd-by w-100 pt-3">
            <h3>POWERED BY</h3>
            <div className="mt-4">
              <div className="col-12 text-center mb-4 powered_by1">
                <a href="https://autoattend.com/" target="_blank" rel="noopener noreferrer"> <img src={autoattend} alt="" className="" /> </a>
                <a href="https://www.hashtagtechnologies.com/" target="_blank" rel="noopener noreferrer"> <img src={hastag} alt="" className=""/> </a>
              </div>
            </div>
          </div>
        </div>


        <div className="row price-col mt-4 mb-5">
          <div className="col-md-4">
            <div className="price-box pt-2 pb-2 mt-2 mb-2 text-center">
              <div className="prize_rank">  <h1> <b> 2  </b> </h1> </div>
              <h3> FIRST RUNNER UP </h3>
              <img className="" src={second_prize} alt="..." />
              <ul className="list-unstyled text-small text-left text-center">
                <li className="mb-1">
                AMAZON KINDLE 10TH GEN
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div className="price-box pt-2 pb-2 mt-2 mb-2 text-center">
              <div className="prize_rank">  <h1> <b> 3  </b> </h1> </div>
              <h3> SECOND RUNNER UP </h3>
              <img className="" src={third_prize} alt="..." />
              <ul className="list-unstyled text-small text-left text-center">
                <li className="mb-1">
                 MI BAND 5
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div className="price-box pt-2 pb-2 mt-2 mb-2 text-center">
              <div className="prize_rank">  <h1> <b> 4  </b> </h1> </div>
              <h3> THIRD RUNNER UP </h3>
              <img className="" src={fourth_prize} alt="..." />
              <ul className="list-unstyled text-small text-left text-center">
                <li className="mb-1">
                GOOGLE HOME MINI
                </li>
              </ul>
            </div>
          </div>
        </div>  

        <div className="row">
          <div className="col-12 middle-part w-100 pt-3">
            <div className="container">
              <div className="row monthly_winners text-center">
               <div className="col-md-8 offset-md-2">
                 <h4 className="pt-3"> MONTHLY WINNERS </h4>
                 <p> In addition to above Prizes, we also have <span> SPECIAL GOODIES </span>  for Monthly Finishers through a random Lucky Draw </p>
                 
               </div> 
               <div className="col-md-10 offset-md-1">
                   <img className="" src={montly_prize1} alt="..." />
                   <img className="" src={montly_prize2} alt="..." />
                   <img className="" src={montly_prize3} alt="..." />
                   <img className="" src={montly_prize4} alt="..." />
                   <img className="" src={montly_prize5} alt="..." />
                   <img className="" src={montly_prize6} alt="..." />
                   <img className="" src={montly_prize7} alt="..." />
               </div>
              </div>
            </div>
          </div>
        </div>    

      </div>
    );
  }
}

export default Prize_winners;
